import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "trophy.icon",
  "use": "trophy.icon-usage",
  "viewBox": "1105.209 -7288.106 28.224 34.507",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"1105.209 -7288.106 28.224 34.507\" id=\"trophy.icon\"><path data-name=\"Small trophy SVG\" d=\"M77.661,47.452c9.037-3.167,9.563-18.266,9.563-18.266H83.793c-.526,1.781-1.255,2.176-1.649,2.307a12.589,12.589,0,0,0-.071-2.378,51.651,51.651,0,0,0-8.966-.6,51.651,51.651,0,0,0-8.966.6s-.071.921-.071,2.378c-.395-.132-1.123-.526-1.65-2.307H59s.526,15.1,9.563,18.266A21.385,21.385,0,0,0,71.4,51.206v.729l-.992.86v.729l.921.921v1.447S68.553,60.9,65.193,61.5v1.518H81.142V61.5c-3.36-.6-6.133-5.606-6.133-5.606V54.444l.921-.921v-.729l-.992-.86v-.729A42.244,42.244,0,0,0,77.661,47.452Zm4.351-14.107a5.909,5.909,0,0,0,2.7-2.965h1.447c-1.579,10.089-5.08,12.589-6.527,13.186A35.155,35.155,0,0,0,82.012,33.345ZM60.052,30.38H61.5a5.909,5.909,0,0,0,2.7,2.965A33.854,33.854,0,0,0,66.64,43.626C65.133,42.969,61.631,40.459,60.052,30.38Z\" transform=\"translate(1046.209 -7316.614)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/trophy.icon.svg
// module id = JXED
// module chunks = 13